import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailPtosis({data, img}) {
    return (
        <MeasurementResult type="안검하수" description='안검하수는 안경 부위에 형성되는 주름을 기리킵니다. 주로 눈을 감았을 때 나타나는 "눈감은 주름"이라고도 불립니다. 피부의 탄력이 감소하고 표정 주름이 깊어지는 과정에서 뚜렷해질 수 있습니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />
                        <img src={img.image_mark_ptosis_front} />

                        <div className="caption">화이트 라이트</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="안검하수"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "경도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중간 정도",
                        label: "5"
                    },
                    {
                        value: "중간 정도",
                        label: "6"
                    },
                    {
                        value: "중증 정도",
                        label: "7"
                    },
                    {
                        value: "중증 정도",
                        label: "8"
                    },
                ]}
                text={data.degreeText}
                levelFloat={data.levelFloat}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}